module.exports = __webpack_public_path__ + "img/liechtenstein.fb3eed41.svg";